<template>
  <div class="mt-2">
    <b-alert :variant="'error'" style="background-color: lightpink" dismissible :show="UI.error !== null" @dismissed="UI.error = null">
      {{UI.error}}
    </b-alert>
    <b-row>
      <b-col class="pl-2 pr-2 col-sm-12 SearchCol">
        <div class="card miniSearch mb-2">
          <div class="card-header">
            <span @click="showJSONPopup()" class="mr-4 pull-right" style="cursor: pointer;"><i class="fa fa-pencil-square-o"></i> Show JSON</span>
            <span class="mb-3">Search Criteria</span>
          </div>
          <div class="card-body p-0">
            <b-row>
              <b-col lg="10">
                <b-row class="mt-2">
                  <b-col v-if="UI.ShowEnterprise">
                    <label class="mb-0" for="InvType">Location</label>
                    <dx-select-box id="ShowEnterprise" :data-source="dealershipLocationTypes" :accept-custom-value="false"
                                display-expr="typeName" value-expr="id" :value.sync="request.Filter.Location"/>
                  </b-col>
                  <b-col v-if="UI.ShowEnterprise">
                    <label class="mb-0">Radius in Miles</label>
                    <b-form-input id="inpRadiusMiles" name="inpRadiusMiles" v-model="request.Miles"
                                  v-validate="{ required: UI.ShowEnterprise, min_value:0 }" @input="onFormInputChanged"></b-form-input>
                    <div v-if="validateErrors.has('inpRadiusMiles')" class="invalid-feedback mb-2" style="display: block">Value must be greater or equal to zero</div>
                  </b-col>
                  <b-col v-if="UI.UsedVehicles">
                    <label class="mb-0" for="InvType">New/Used</label>
                    <dx-select-box id="NewUsedDropDown" :items="['Both','New','Used']" :value.sync="request.InvType" />
                  </b-col>
                  <b-col>
                    <label class="mb-0" for="ScanMode">Lease/Finance</label>
                    <dx-select-box id="ScanTypedd" :items="['Both','Lease','Finance']" :value.sync="request.ScanMode" />
                  </b-col>
                  <b-col>
                    <label class="mb-0" for="cash">Cash</label>
                    <msis-currency-input id="inpCash" name="cash" v-model="request.Cash" v-validate="{ required: true, min_value:0 }" @input="onFormInputChanged"></msis-currency-input>
                    <div v-if="validateErrors.has('cash')" class="invalid-feedback mb-2" style="display: block">Value must be positive value</div>
                  </b-col>
                  <b-col v-if="request.ScanMode !== 'Finance'">
                    <label class="mb-0">Annual Miles</label>
                    <b-form-input id="inpAnnualMileage" name="annualMileage" v-model="request.AnnualMileage"
                                  v-validate="{ required: request.ScanMode !== 'Finance', min_value:1 }" @input="onFormInputChanged"></b-form-input>
                    <div v-if="validateErrors.has('annualMileage')" class="invalid-feedback mb-2" style="display: block">Value must be greater than zero</div>
                  </b-col>
                  <b-col>
                    <label class="mb-0">Credit Score</label>
                    <b-form-input id="inpCreditScore" name="creditScore"
                                  v-validate="{ required: true, min_value: 300, max_value: 850}"
                                  min="300"
                                  step="10"
                                  v-model="request.CreditScore"
                                  @input="onFormInputChanged"></b-form-input>
                    <div v-if="validateErrors.has('creditScore')" class="invalid-feedback" style="display: block">Credit score must be within a valid credit score range</div>
                  </b-col>
                </b-row>
                <b-row class="mt-2 mb-2">
                  <b-col>
                    <label class="mb-0">Min. Pmt.</label>
                    <msis-currency-input id="inpMinPayment" name="minPayment"
                                         v-model="request.Filter.MinPayment"
                                         v-validate="{ required: true, min_value:1 }"
                                         @input="onFormInputChanged">
                    </msis-currency-input>
                    <div v-if="validateErrors.has('minPayment')" class="invalid-feedback" style="display: block">Value must be greater than zero</div>
                  </b-col>
                  <b-col>
                    <label class="mb-0">Max. Pmt.</label>
                    <msis-currency-input id="inpMaxPayment" name="maxPayment"
                                         v-model="request.Filter.MaxPayment"
                                         v-validate="{ required: true, min_value: request.Filter.MinPayment}"
                                         @input="onFormInputChanged">
                    </msis-currency-input>
                    <div v-if="validateErrors.has('maxPayment')" class="invalid-feedback" style="display: block">Max payment must be greater than min payment</div>
                    <div v-if="fixCurrency(request.Filter.MaxPayment) < 1" class="invalid-feedback" :class="{ 'is-invalid': validateErrors.has('maxPayment') }" style="display: block;" name="maxPayment">Value must be greater than zero</div>
                  </b-col>
                  <b-col>
                    <label class="mb-0">Min. Term</label>
                    <b-form-input id="inpMinTerm" v-model="UI.minimumTerm"
                                  name="minimumTerm"
                                  v-validate="{ required: true, min_value: 1}"
                                  @input="onFormInputChanged"></b-form-input>
                    <div v-if="validateErrors.has('minimumTerm')" class="invalid-feedback" style="display: block">Value must be greater than zero</div>
                  </b-col>
                  <b-col>
                    <label class="mb-0">Max. Term</label><br />
                    <b-form-input id="inpMaxTerm" name="maxTerm"
                                  v-model="UI.maximumTerm"
                                  v-validate="{ required: true, min_value: UI.minimumTerm}"
                                  @input="onFormInputChanged"></b-form-input>
                    <div v-if="validateErrors.has('maxTerm')" class="invalid-feedback" style="display: block">Max term must be greater than min term</div>
                    <div v-if="fixCurrency(UI.maximumTerm) < 1" class="invalid-feedback" :class="{ 'is-invalid': validateErrors.has('maxTerm') }" style="display: block;">Value must be greater than zero</div>
                  </b-col>
                  <b-col v-if="!UI.HideTrade">
                    <label class="mb-0" for="Allowance">Allowance</label>
                    <msis-currency-input id="inpTradeAlowance" name="Allowance" v-model="request.TradeIn.Allowance" v-validate="{ required: true, min_value:0 }" @input="onFormInputChanged"></msis-currency-input>
                    <div v-if="validateErrors.has('Allowance')" class="invalid-feedback mb-2" style="display: block">Value must be positive value</div>
                  </b-col>
                  <b-col v-if="!UI.HideTrade">
                    <label class="mb-0" for="PayOff">Trade Pay-Off</label>
                    <msis-currency-input id="inpTradePayOff" name="PayOff" v-model="request.TradeIn.PayOff" v-validate="{ required: false, min_value:0 }" @input="onFormInputChanged"></msis-currency-input>
                    <div v-if="validateErrors.has('PayOff')" class="invalid-feedback mb-2" style="display: block">Value must be positive value</div>
                  </b-col>
                  <b-col v-if="!UI.HideTrade">
                    <label class="mb-0">&nbsp; </label>
                    <b-form-checkbox id="chkLeaseTrade" class="mx-3" v-model="request.TradeIn.IsLeased">Trade is Lease</b-form-checkbox>
                  </b-col>
                </b-row>
              </b-col>
              <b-col lg="2" class="text-center">
                <b-img id="btnWhatCanIDrive" @click="tryGetGridInfo()" v-bind:src="UI.mdrivePowerState" fluid-grow class="mt-2 mDriveButton" style="max-width:125px;cursor:pointer;" />
              </b-col>
            </b-row>
          </div>
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col class="pl-2 mr-0 pr-2 pb-2 GridCol" sm="12" md="12" lg="12">
        <b-col class="col-lg-8 offset-lg-2" v-if="showLogo">
          <div class="col-lg-7 offset-lg-2" style="text-align: center; height: 100%; opacity: 0.7; filter: alpha(opacity=70); overflow:hidden;">
            <div style="text-align: right; margin-top: calc(50vh - 300px);">
              <img src="/web/img/mdrive_logo.png" alt="mDrive Logo" class="img-fluid">
              <h4 style="margin-right: 5rem !important;">What can I drive?</h4>
            </div>
          </div>
        </b-col>

        <b-card id="searchResults" class="mediaHeight searchResultsHeight pb-0 mb-2" v-if="!showLogo">
          <div slot="header">
            <div>
              <span class="float-left">Search Results</span>
              <div class="float-left" v-if="records !== null && records.length > 0">
                <small class="p-1">&nbsp;({{toCommas(UI.rowCount)}} of {{toCommas(records.length)}})</small>
              </div>
              <small class="float-left ml-1 mt-1">
                <a id="btnClearAllFilt" href="#" @click="dataGridInstance.clearFilter('header')">Clear All Filters</a>
              </small>
              <div class="text-right">{{UI.dateLastRun}}</div>
            </div>
          </div>

          <dx-data-grid id="grid-container"
                        :show-borders="false"
                        :row-alternation-enabled="true"
                        :data-source="records"
                        @row-click="onRowClick"
                        v-on:contentReady="onContentReady"
                        :allow-column-resizing="true"
                        :column-min-width="50"
                        :column-auto-width="true"
                        :paginate="false"
                        ref="gridcontainer">
            <!--:useNative="records.length == 0"-->
            <dx-scrolling mode="virtual" :useNative="true" />
            <!--mode="virtual"-->
            <!--<dx-paging
                     mode="standard"
                     :page-size="12" />
          <dx-pager :show-page-size-selector="true"
                    :allowed-page-sizes="null"
                    :show-info="true" />-->
            <dx-header-filter :visible="true"
                              :useNative="true"
                              :showScrollarbar="'always'" />
            <dx-search-panel :visible="true"
                             :width="240"
                             placeholder="Search..." />
            <dx-column :visible.sync="UI.ShowEnterprise"
                       data-field="DealershipName"
                       alignment="left"
                       caption="Dealership" />

            <dx-column data-field="Year"
                       alignment="center"
                       caption="Year" />

            <dx-column data-field="InvType"
                       alignment="center"
                       caption="Type" />

            <dx-column data-field="Make"
                       caption="Make"
                       :header-filter="{allowSearch: true}" />

            <dx-column data-field="Model"
                       caption="Model"
                       :header-filter="{allowSearch: true}"
                       [position]="left" />

            <dx-column data-field="Trim"
                       caption="Trim"
                       :header-filter="{allowSearch: true}" />

            <dx-column data-field="MSRP"
                       caption="MSRP"
                       :allowFiltering="false"
                       alignment="center"
                       format="currency" />

            <dx-column data-field="ExteriorColor"
                       caption="Color"
                       :header-filter="{allowSearch: true}" />

            <dx-column data-field="BestTerm"
                       caption="Term"
                       alignment="center" />

            <dx-column data-field="BestPayment"
                       :allowFiltering="false"
                       format="currency"
                       caption="Est. Pmt."
                       alignment="center" />

            <dx-column data-field="LotAge"
                       :visible="!UI.kioskMode"
                       :allowFiltering="false"
                       :caption=UI.LotAgeLabel
                       alignment="center" />

            <dx-column data-field="BestPVI"
                       :allowFiltering="false"
                       sortOrder="desc"
                       caption="PVI"
                       alignment="center" />

            <dx-column data-field="PaymentType"
                       caption="Pmt. Options"
                       alignment="center" />

            <dx-master-detail v-once :enabled="true" template="masterDetailTemplate" />
            <template #masterDetailTemplate="{ data: data }">
              <b-row>
                <b-col>
                  <p>VIN: {{data.data.VIN}}</p>
                  <p>Stock#: {{data.data.StockNumber}}</p>
                  <p>Year: {{data.data.Year}}</p>
                  <p>Type: {{data.data.InvType}}</p>
                  <p>Make: {{data.data.Make}}</p>
                  <p>Model: {{data.data.Model}}</p>
                  <p>Trim: {{data.data.Trim}}</p>
                  <p>Color: {{data.data.ExteriorColor}}</p>
                  <p v-if="data.data.InvType === 'Used'">Miles: {{data.data.Miles}}</p>
                  <p v-if="!UI.kioskMode">Lot Age: {{data.data.LotAge}}</p>
                </b-col>

                <b-col v-if="data.data.Lease">
                  <strong v-if="data.data.Lease">Lease</strong>
                  <sub-grid v-if="data.data.Lease" :dataSource.once="data.data.Lease" :kioskMode="UI.kioskMode" :currentRow="data.data" :paymentType="true" :request="request" v-on:showPushPopup="onShowPushPopup" :pushToWebhookAccess="UI.PushToWebhookAccess" />
                  <span v-if="data.data.Lease">{{data.data.Lease.length}} lease option{{data.data.Lease.length > 1 ? 's' : ''}}</span>
                </b-col>
                <b-col v-if="data.data.Retail">
                  <strong v-if="data.data.Retail">Finance</strong>
                  <sub-grid v-if="data.data.Retail" :dataSource.once="data.data.Retail" :kioskMode="UI.kioskMode" :currentRow="data.data" :paymentType="false" :request="request" v-on:showPushPopup="onShowPushPopup" :pushToWebhookAccess="UI.PushToWebhookAccess" />
                  <span v-if="data.data.Retail">{{data.data.Retail.length}} finance option{{data.data.Retail.length > 1 ? 's' : ''}}</span>
                </b-col>
                <b-col v-if="!(data.data.Lease && data.data.Retail)"></b-col>
                <b-col v-if="!(data.data.Lease && data.data.Retail)"></b-col>
                <b-col v-if="(data.data.Lease && data.data.Retail)"></b-col>
              </b-row>
            </template>
          </dx-data-grid>
        </b-card>
      </b-col>
    </b-row>

    <DxPopup :visible.sync="showPushPopupVisible"
             :drag-enabled="false"
             :close-on-outside-click="true"
             :show-title="true"
             :width="600"
             :height="450"
             title="Push Deal"
             ref="pushPopup">
      <div class="row mb-2">
        <div class="col-md-6">
          <div>
            Stock#: {{selectedProgram.StockNumber}}
          </div>
          <div v-if="selectedProgram.IsLease === true">
            Annual Mileage: {{selectedProgram.AnnualMileage}}
          </div>
          <div v-if="selectedProgram.InvType === 'Used'">
            Miles: {{selectedProgram.Miles}}
          </div>
          <div>
            Credit Score: {{selectedProgram.CreditScore}}
          </div>
          <div>
            Estimated Payment: ${{selectedProgram.DesiredPayment}}
          </div>
        </div>
        <div class="col-md-6">
          <div v-if="selectedProgram.InvType == 'Used'">
            Price: ${{toDecimalLimited(selectedProgram.UsedBookValue,2)}}
          </div>
          <div v-else>
            MSRP: ${{toDecimalLimited(selectedProgram.MSRP,2)}}
          </div>
          <div>
            Customer Cash: ${{toDecimalLimited(selectedProgram.Cash,2)}}
          </div>
          <div>
            {{selectedProgram.IsLease === true ? 'Lease' : 'Finance'}} Term: {{selectedProgram.Term}}
          </div>
          <div v-if="!validatingPayment">
            <strong>Calculating Payment...</strong>
          </div>
          <div v-else>
            Calculated Payment: ${{toDecimalLimited(selectedProgram.CalculatedPayment,2)}}
          </div>
        </div>
      </div>
      <div class="row mb-2">
        <div class="col-md-5">
        </div>
        <div class="col-md-3">
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <label class="mb-0">Customer Name</label>
          <b-form-input name="customerName" v-model="customerName" v-validate="{ required: showPushPopupVisible }" lazy></b-form-input>
          <div v-if="validateErrors.has('customerName')" class="invalid-feedback mb-2" style="display: block">Customer Name Required</div>
          <div v-else class="mb-2">&nbsp;</div>
        </div>
      </div>
      <div class="row" v-bind:class="{'disabledTab': !validatingPayment }">
        <div class="col-md-3 text-center">
          <h1 @click="pushTomDesking()" class="my-1" style="cursor:pointer;"><i class="fa fa-pencil-square-o"></i></h1>
          <div>to mDesking</div>
        </div>
        <div class="col-md-3 text-center">
          <h1 @click="previewPdf()" class="my-1" style="cursor:pointer;"><i class="fa fa-file-text"></i></h1>
          <div>Preview Deal</div>
        </div>
        <div class="col-md-3 text-center">
          <h1 @click="pushToPdf()" class="my-1" style="cursor:pointer;"><i class="fa fa-envelope-open"></i></h1>
          <div>Email PDF</div>
        </div>
        <div class="col-md-3 text-center">
          <h1 @click="pushToWebhook()" class="my-1" style="cursor:pointer;"><i class="fa fa-cogs"></i></h1>
          <div>to Partner</div>
        </div>
      </div>
      <div class="row mt-4">
        <div class="col-md-12">
          <div role="alert" aria-live="polite" aria-atomic="true" class="alert alert-info">
            <strong>Payment Disclosure</strong><br />
            <span>Payments shown are based on the dealerships location and tax rates/rules, which may be different from the customer's tax location.</span>
          </div>
        </div>
      </div>
    </DxPopup>

    <DxPopup :visible.sync="showJSONPopupVisible"
             :drag-enabled="false"
             :close-on-outside-click="true"
             :show-title="true"
             :width="800"
             :height="650"
             title="JSON Request"
             ref="jsonPopup">
      <div class="row mb-2">
        <div class="col-md-6">
          <div>
            <editor v-model="popupJSONRequest" @init="editorInit" width="730" height="550" lang="JSON" theme="chrome"></editor>
          </div>
        </div>
      </div>
    </DxPopup>

    <loading :show="UI.boolLoading"
             :label="UI.txtLoading">
    </loading>
  </div>
</template>
<script>
import Vue from 'vue'
import axios from 'axios'
import money from 'v-money'
import router from '@/router'
import notify from 'devextreme/ui/notify'
import tachyons from 'tachyons'
import loading from 'vue-full-loading'
import image from '../assets/logo.png'
import VueCookies from 'vue-cookies'
import MaskedInput from 'vue-masked-input'

import DataSource from 'devextreme/data/data_source'
import 'devextreme/dist/css/dx.common.css'
import { DxPopup } from 'devextreme-vue/popup'

// import 'devextreme/dist/css/dx.material.blue.light.css';

import { isNull } from 'util'
import {
  DxDataGrid,
  DxColumn,
  DxHeaderFilter,
  DxSearchPanel,
  DxFilterRow,
  DxMasterDetail,
  DxPager,
  DxPaging,
  DxScrolling,
  DxLoadPanel
} from 'devextreme-vue/data-grid'

import {
  DxTextBox,
  DxNumberBox,
  DxLookup,
  DxSelectBox,
  DxSwitch,
  DxDropDownBox
} from 'devextreme-vue'

Vue.use(money, { precision: 4 })
Vue.use(VueCookies)

Vue.component('sub-grid', {
  components: {
    DxDataGrid,
    DxColumn,
    DxPaging
  },
  props: ['dataSource', 'kioskMode', 'currentRow', 'paymentType', 'request', 'pushToWebhookAccess'],
  template: `<dx-data-grid :height="200" :data-source.once="dataSource" :show-borders="true" :column-auto-width="true">
                 <dx-paging :page-size="9999" />
                 <dx-column data-field="Term" alignment="left" width="80" />
                 <dx-column data-field="Payment" width="100" caption="Est. Pmt." format="currency" />
                 <dx-column data-field="PVI" width="110" sortOrder="desc" />
                 <dx-column type="buttons" :buttons="pushDealButton" :width="80" v-if=\"pushToWebhookAccess\" />
               </dx-data-grid>`,
  data () {
    let self = this
    return {
      pushDealButton: [{
        hint: 'Push Deal',
        icon: 'repeat',
        onClick: function (e) {
          let program = {
            'VIN': self.currentRow.VIN,
            'InvType': self.currentRow.InvType,
            'StockNumber': self.currentRow.StockNumber,
            'Year': self.currentRow.Year,
            'Make': self.currentRow.Make,
            'Model': self.currentRow.Model,
            'Trim': self.currentRow.Trim,
            'Color': self.currentRow.ExteriorColor,
            'Cash': self.request.Cash,
            'AnnualMileage': self.request.AnnualMileage,
            'IsLease': self.paymentType,
            'Term': e.row.data.Term,
            'CreditScore': self.request.CreditScore,
            'MSRP': self.currentRow.MSRP,
            'DesiredValue': self.currentRow.DesiredValue,
            'ScanType': self.currentRow.ScanType,
            'DesiredPayment': e.row.data.Payment,
            'UsedBookValue': self.currentRow.UsedBookValue,
            'Miles': self.currentRow.Miles
          }
          self.$emit('showPushPopup', program)
        }
      }]
    }
  }
})

// Validator.extend('less-than-min-pmt', {
//  getMessage: field => 'The ' + field + ' value is not truthy.',
//  validate: value => console.log(value)
// });

// <dx-paging :enabled="false" pageSize="0"/>

const defaultLeaseTermOptions = [12, 15, 18, 21, 24, 25, 26, 27, 28, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 48, 49, 50, 51, 52, 54, 57, 60, 66, 72, 75, 78, 84, 88, 90, 96]

const defaultPaymentOptions = [0, 500, 600, 700, 800, 900, 1000, 1100, 1200, 1300, 1400, 1500, 1600, 1700, 1800, 1900, 2000, 2100, 2200, 2300, 2400, 2500, 2600, 2700, 2800, 2900, 3000, 3100, 3200, 3300, 3400, 3500, 3600, 3700, 3800, 3900, 4000, 4100, 4200, 4300, 4400, 4500, 4600, 4700, 4800, 4900, 5000, 5100, 5200, 5300, 5400, 5500, 5600, 5700, 5800, 5900, 6000, 6100, 6200, 6300, 6400, 6500, 6600, 6700, 6800, 6900, 7000, 7100, 7200, 7300, 7400, 7500, 7600, 7700, 7800, 7900, 8000, 8100, 8200, 8300, 8400, 8500, 8600, 8700, 8800, 8900, 9000, 9100, 9200, 9300, 9400, 9500, 9600, 9700, 9800, 9900, 10000, 10100, 10200, 10300, 10400, 10500]

const isNullOrUndefined = function (val) { return typeof val === 'undefined' || val === null }

const defaultErrorMsg = 'There was an error made during your request.  Please verify that you have entered your information correctly'

const fixCurrency = function (str) {
  if (isNullOrUndefined(str)) return 0

  var val = str.replace('$', '').replace(',', '')

  return parseInt(val)
}

function bestCopyEver (src) { return Object.assign({}, src) }

function GetDomain () {
  var l = window.location.host.split('.')
  if (l.length >= 3 && window.location.host.indexOf(':') === -1) {
    return l[1] + '.' + l[2]
  } else {
    return window.location.host
  }
}

function parseInts (request) {
  var req2 = bestCopyEver(request)

  for (var i in req2) {
    var r = request[i]
    if (typeof r === 'string' && r.startsWith('$')) r = r.replace('$', '').replace(',', '')
    if (request.hasOwnProperty(i) && !isNaN(r)) {
      req2[i] = parseFloat(r)
    }
  }

  if (typeof request.Filter.MaxPayment === 'string') { request.Filter.MaxPayment = parseFloat(request.Filter.MaxPayment.replace('$', '').replace(',', '')) }

  if (typeof request.Filter.MinPayment === 'string') { request.Filter.MinPayment = parseFloat(request.Filter.MinPayment.replace('$', '').replace(',', '')) }

  // console.log(req2)

  return req2
}

window.mobilecheck = function () {
  var check = false;
  (function (a) { if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true })(navigator.userAgent || navigator.vendor || window.opera)
  return check
}

const creditScoreInfo = [
  { eval: 'score >= 800', caption: 'Exceptional' },
  { eval: 'score >= 740 && score < 800', caption: 'Very Good' },
  { eval: 'score >= 670 && score < 740', caption: 'Good' },
  { eval: 'score >= 580 && score < 670', caption: 'Fair' },
  { eval: 'score < 580', caption: 'Poor' }
]

const GetCreditScoreCaption = function (score) {
  if (isNullOrUndefined(score)) return

  for (var i in creditScoreInfo) {
    var creditScore = creditScoreInfo[i]
    if (eval(creditScore.eval)) {
      return creditScore.caption
    }
  }
}

Vue.component('msis-currency-input', {
  props: ['value'],
  template: `
        <div>
            <input type='text'
                   class='form-control'
                   ref='currencyInput'
                   v-model='displayValue'
                   @blur='isInputActive = false;' />
        </div>`,
  data: function () {
    return {
      isInputActive: false
    }
  },
  computed: {
    displayValue: {
      get: function () {
        if (this.isInputActive) {
          // Cursor is inside the input field. unformat display value for user.
          return this.value.toString()
        } else {
          // User is not modifying now. Format display value for user interface.
          return '$' + this.value.toString()
        }
      },
      set: function (modifiedValue) {
        this.isInputActive = true

        let newValue = parseInt(modifiedValue.replace('$', '')).toString().replace(/[^\d\.]/g, '')

        if (isNaN(newValue)) {
          newValue = 0
        }

        this.$emit('input', newValue)
      }
    }
  }
})

export default {
  components: {
    tachyons,
    loading,
    DxDataGrid,
    DxColumn,
    DxHeaderFilter,
    DxSearchPanel,
    DxFilterRow,
    DxMasterDetail,
    DxPager,
    DxPaging,
    DxScrolling,
    MaskedInput,
    DxLoadPanel,
    DxSelectBox,
    DxPopup,
    editor: require('vue2-ace-editor')
  },
  created () {
    this.getDefaultValues()
    this.getMDriveFeature()
    this.getAccountLocation()
  },
  data () {
    return {
      showLogo: true,
      showPushPopupVisible: false,
      showJSONPopupVisible: false,
      popupJSONRequest: '',
      selectedProgram: {},
      validatingPayment: false,
      customerName: '',
      records: [],
      dealershipLocationTypes: new DataSource({
                store: [
                  { id: 1, typeName: "My Dealership" },
                  { id: 2, typeName: "All Dealerships" },
                ],
              key: "id"
            }),
  
      data: {
        defaultDataUrl: '', // api/LoadEmptyData
        testUrl: 'api/GetData',
        mdriveFeature: {}
      },

      UI: {
        mdrivePowerState: '/web/img/mdrive_power_off.jpg',
        PushTomDeskingAccess: false,
        PushToWebhookAccess: false,
        HideTrade: false,
        ShowEnterprise: false,
        UsedVehicles: false,
        LotAgeLabel: 'Lot Age',
        rowClicked: false, // added for NADA.  remove later
        dpSignedIn: false,
        dxColumnMode: 'widget',

        txtLoading: 'Loading...',
        boolLoading: false,

        kioskMode: true,

        defaults: {},

        rowCount: 0,
        creditScore: 720,
        paymentOptions: defaultPaymentOptions,
        fromPayment: 500,
        toPayment: 1000,

        minimumTerm: 12,
        maximumTerm: 36,
        terms: defaultLeaseTermOptions,

        money: {
          decimal: '.',
          thousands: ',',
          prefix: '$',
          //  suffix: ' #',
          precision: 0,
          masked: true
        },

        submitted: false,
        error: null,
        sortBy: 'StockNumber',
        sortDesc: false,
        logo: image,
        dateLastRun: ''
      },

      request: {
        'Miles': 0,
        'Lat': 34.225399,
        'Lng': -119.050667,
        'ScanMode': 'Both',
        'InvType': 'Both',
        'AnnualMileage': 12000,
        'Cash': 1000.0,
        'CreditScore': 720,
        'Filter': {
          'IsNew': true,
          'Term': [],
          'NoLeaseData': false,
          'NoRetailData': false,
          'MinPayment': 500.0,
          'MaxPayment': 900.0,
          'Location': 1
        },
        'TradeIn': {
          'IsLeased': false,
          'Allowance': 0.00,
          'PayOff': 0.00
        }
      }
    }
  },
  methods: {

    debug (txt) { console.log(txt) },

    onShowPushPopup (program) {
      let self = this
      self.validatingPayment = false
      self.showPushPopupVisible = true
      self.selectedProgram = program
      if (!isNaN(parseFloat(self.request.TradeIn.Allowance))) {
        if (isNaN(parseFloat(self.request.TradeIn.PayOff))) {
          self.request.TradeIn.PayOff = 0
        }
        self.selectedProgram['TradeIn'] = self.request.TradeIn
      } else {
        self.selectedProgram['TradeIn'] = null
      }
      self.UI.txtLoading = 'Please wait... '
      axios.post('/api/mdrive/getbestpayment', self.selectedProgram)
        .then(response => {
          self.validatingPayment = true
          self.selectedProgram.CalculatedPayment = response.data.data.bestPayment
          self.selectedProgram.ProgramId = response.data.data.programId
          self.selectedProgram.AdvanceSource = response.data.data.AdvanceSource
          self.selectedProgram.DealerZip = response.data.data.dealerZip
          self.selectedProgram.Market = response.data.data.market
          console.log(response); // for QA
        })
        .catch(error => {
          self.validatingPayment = true
          console.log(error)
          notify('Failed to update payment', 'warning', 5500)
        })
    },

    showJSONPopup () {
      self = this
      self.showJSONPopupVisible = true
      self.request.Filter.Term = self.getFromToValues(self.UI.minimumTerm, self.UI.maximumTerm)
      self.popupJSONRequest = JSON.stringify(parseInts(self.request), null, '\t')
    },

    editorInit: function () {
      require('brace/ext/language_tools')
      require('brace/mode/html')
      require('brace/mode/javascript')
      require('brace/mode/less')
      require('brace/theme/chrome')
    },

    pushTomDesking () {
      let self = this
      if (!self.UI.PushTomDeskingAccess) {
        notify('You are currently not subscribed to mDesking. Please contact support for more information.', 'warning', 10500)
        return
      }
      if (self.customerName === undefined || self.customerName.length === 0) { return }
      self.UI.boolLoading = true
      self.selectedProgram['CustomerName'] = self.customerName
      axios.post('/api/mdrive/pushtomdesking', self.selectedProgram)
        .then(response => {
          self.UI.boolLoading = false
          self.showPushPopupVisible = false
          notify('Successfully pushed deal to mDesking', 'success', 3500)
        })
        .catch(error => {
          notify('There was an error processing your request', 'warning', 5500)
          self.UI.boolLoading = false
          self.showPushPopupVisible = false
          self.handleDefaultException(error)
        })
    },

    pushToPdf () {
      let self = this
      if (self.customerName === undefined || self.customerName.length === 0) { return }
      self.UI.boolLoading = true
      self.selectedProgram['CustomerName'] = self.customerName
      axios.post('/api/mdrive/pushtopdf', self.selectedProgram)
        .then(response => {
          self.UI.boolLoading = false
          self.showPushPopupVisible = false
          notify('Successfully pushed deal to manager\'s email', 'success', 3500)
        })
        .catch(error => {
          notify('There was an error processing your request', 'warning', 5500)
          self.UI.boolLoading = false
          self.showPushPopupVisible = false
          self.handleDefaultException(error)
        })
    },

    previewPdf () {
      let self = this
      if (self.customerName === undefined || self.customerName.length === 0) { return }
      self.UI.boolLoading = true
      self.selectedProgram['CustomerName'] = self.customerName
      self.selectedProgram['viewPDF'] = true
      const options = {
        method: 'POST',
        data: self.selectedProgram,
        responseType: 'blob',
        url: '/api/mdrive/pushtopdf'
      }
      axios(options)
        .then(response => {
          self.UI.boolLoading = false
          self.showPushPopupVisible = false
          self.selectedProgram.viewPDF = undefined
          let fileName = response.headers['content-disposition'].split('filename=')[1]
          const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }))
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', response.headers['content-disposition'].split('filename=')[1])
          document.body.appendChild(link)
          link.click()
        })
        .catch(error => {
          notify('There was an error processing your request', 'warning', 5500)
          self.selectedProgram.viewPDF = undefined
          self.UI.boolLoading = false
          self.showPushPopupVisible = false
          self.handleDefaultException(error)
        })
    },

    pushToWebhook () {
      let self = this
      if (!self.UI.PushToWebhookAccess) {
        notify('You are currently not subscribed for this feature. Please contact support for more information.', 'warning', 10500)
        return
      }
      if (self.customerName === undefined || self.customerName.length === 0) { return }
      self.UI.boolLoading = true
      self.selectedProgram['CustomerName'] = self.customerName
      axios.post('/api/mdrive/sendwebhook', self.selectedProgram)
        .then(response => {
          self.UI.boolLoading = false
          self.showPushPopupVisible = false
          notify('Successfully pushed deal to custom webhook', 'success', 4000)
          window.open('https://webhook.site/#!/7ea01fea-68ae-4f02-9f85-f868b1217693/02d54470-adf6-46cd-8670-6dfe9e54a441/1', '_blank')
        })
        .catch(error => {
          notify('There was an error processing your request', 'warning', 5500)
          self.UI.boolLoading = false
          self.showPushPopupVisible = false
          self.handleDefaultException(error)
        })
    },

    tryGetGridInfo () {
      this.debug('tryGetGridInfo')
      if (this.ActiveSubscription !== true) {
        return
      }
      var self = this
      this.$validator.validateAll().then((valid) => {
        if (valid) { self.getGridInfo() } else {
          self.UI.error = 'There are errors in your submission that must be fixed before your request can be sent.'
        }
      })
    },

    getGridInfo () {
      var self = this
      self.showLogo = false
      self.UI.boolLoading = true
      self.UI.txtLoading = 'Searching for vehicles...'
      var request = { request: parseInts(self.request) }
      request.request.Filter.Term = self.getFromToValues(self.UI.minimumTerm, self.UI.maximumTerm)
      self.UI.error = null

      axios.post('/api/mdrive/getdata', JSON.stringify(request)).then(response => {
        self.UI.txtLoading = 'Search is taking longer than expected.. '
        self.UI.kioskMode = response.data.kioskMode
        self.handleErrors(response.data)
        console.log(response)
        self.records = response.data.data || []
        self.UI.boolLoading = false
        self.UI.mdrivePowerState = '/web/img/mdrive_power_on.jpg'
      }).catch(error => {
        self.handleDefaultException(error)
      })
    },

    getDefaultValues () {
      var self = this
      var settingsCookie = this.$cookies.get('mDriveSettings')

      if (settingsCookie != null) {
        this.setDefaults(settingsCookie)
        return
      }

      axios.get('/api/mdrive/getdefaults').then(response => {
        self.setDefaults(response.data)
        self.handleErrors(response.data)
      }).catch(error => {
        self.handleDefaultException(error)
      })

      axios.get('/api/mdrive/getlastrundate').then(response => {
        self.UI.dateLastRun = response.data
      }).catch(error => {
        self.handleDefaultException(error)
      })
    },
    getMDriveFeature () {
      var self = this
      self.boolLoading = true
      axios.post('/api/mdrive/getmdrivefeature', self.request)
        .then(response => {
          self.mdriveFeature = response.data.feature[0]
          self.FeatureSubcriptionError(response.data.feature[0])

          self.handleErrors(response.data)
        })
        .catch(error => {
          self.handleDefaultException(error)
        })
    },
    setDefaults (defaults) {
      this.request.AnnualMileage = defaults.AnnualMileage
      this.request.Cash = defaults.Cash
      this.request.CreditScore = defaults.CreditScore
      this.request.Filter.MinPayment = defaults.MinPayment
      this.request.Filter.MaxPayment = defaults.MaxPayment
      this.UI.minimumTerm = defaults.MinTerm
      this.UI.maximumTerm = defaults.MaxTerm
      this.UI.PushTomDeskingAccess = defaults.PushTomDeskingAccess
      this.UI.PushToWebhookAccess = defaults.PushToWebhookAccess
      this.UI.HideTrade = defaults.HideTrade
      this.UI.ShowEnterprise = defaults.ShowEnterprise
      this.UI.UsedVehicles = defaults.UsedVehicles
      this.UI.LotAgeLabel = defaults.LotAgeLabel
    },

    getAccountLocation() {
      var self = this
      self.boolLoading = true
      debugger;
      axios.get('/api/mdrive/getaccountlocation').then(response => {
        if (response.data != null) {
          self.request.Lat = response.data.Item1
          self.request.Lng = response.data.Item2
        }
      }).catch(error => {
        self.handleDefaultException(error)
      })
    },
        
    // helper
    handleErrors (data) {
      if (data.hasOwnProperty('error')) {
        switch (data.type) {
          case 0: // hidden
            break
          case 1: // visible
            this.UI.error = data.error
            console.error(data.error)
            break
          case 2: // console
            this.UI.error = defaultErrorMsg
            console.error(data.error)
            break
        }
        this.clearRecords()
      }
    },

    handleDefaultException (error) {
      console.error(error)
      this.UI.error = 'There was an error made during your request.  Please verify that you have entered your information correctly'
      this.clearRecords()
      this.UI.boolLoading = false
    },
    FeatureSubcriptionError (feature) {
      this.ActiveSubscription = true
      if ((feature.HasFeature !== true)) {
        this.UI.error = 'You are not allowed to perform this action. mDrive is not part of your subscription, please contact 888-658-7226.'
        this.ActiveSubscription = false
      }
      this.clearRecords()
      this.UI.boolLoading = false
    },

    clearRecords () {
      this.records = []
    },

    getFromToValues (from, to) {
      from = parseInt(from)
      to = parseInt(to) + 1
      var cpy = Array(to).fill(1).map((x, y) => x + y)
      var _fromIndex = cpy.indexOf(from)
      var _toIndex = cpy.indexOf(to)
      return cpy.slice(_fromIndex, _toIndex)
    },

    toCommas (value) {
      if (value === null || typeof value === 'undefined') return ''

      return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    },

    toCurrency (value) {
      if (isNaN(value) || typeof value === 'undefined' || value === '' || value === null) return value

      value = value.toString()

      return '$' + this.toCommas(value)
    },

    toCurrencyWithDecimals (value) {
      if (isNaN(value) || typeof value === 'undefined' || value === '' || value === null) return value

      value = value.toString()

      var dec = value.includes('.') ? '' : '.00'

      return '$' + this.toCommas(value) + dec
    },

    fixCurrency (str) {
      // this.debug(str)
      if (typeof str === 'number') { return str }

      return fixCurrency(str)
    },
    toDecimalLimited (value, decimal_number) {
      if (isNaN(value) || typeof value === 'undefined' || value === '' || value === null) return value
      value = value.toString()
      var dec = '.00'
      if (value.includes('.')) {
        dec = '' + value.split('.')[1]
        value = '' + value.split('.')[0]
        dec = dec + '00'
        if (dec.length > 0 && dec.length > decimal_number) {
          dec = '.' + dec.substring(0, decimal_number)
        } else {
          dec = '.' + dec
        }
      }
      return value + dec
    },
    /* Evt */
    onFormInputChanged ({ type, target }) {
      this.clearRecords()
      this.UI.mdrivePowerState = '/web/img/mdrive_power_off.jpg'
    },

    onContentReady (ctx) {
      this.UI.rowCount = ctx.component.totalCount()
    },

    onRowClick (row) {
      if (row.rowType === 'detail') { return }
      var index = row.rowIndex

      if (this.rowClicked) {
        this.rowClicked = false
        return
      }
      row.component.expandRow(index)
      var rowEl = row.component.getRowElement(index)
      rowEl[0].children[0].click()
      this.rowClicked = true
      this.$refs['gridcontainer'].instance.expandRow(index)
    }
  },

  computed: {
    creditScoreCaption () { return GetCreditScoreCaption(this.request.CreditScore) },

    termTo () {
      var l = []
      for (var i in this.UI.terms) {
        var term = this.UI.terms[i]
        if (term >= this.UI.minimumTerm) { l.push(term) }
      }
      return l
    },

    paymentTo () {
      var l = []
      for (var i in this.UI.paymentOptions) {
        var paymentTo = this.UI.paymentOptions[i]
        if (paymentTo >= this.request.Filter.MinPayment) { l.push(paymentTo) }
      }
      return l
    },

    dataGridInstance () {
      window.inst = this.$refs['gridcontainer'].instance
      return window.inst
    }
  }
}
</script>
<style>

  /* validation */
  .app-footer {
    display:none;
  }

  .disabledTab {
    pointer-events: none;
  }

  .is-invalid {
    border-color: #dc3545;
  }

  #grid-container {
    min-width: 50%;
    max-width: 100%;
    max-height: 674px;
    width: 100%
  }

  .dx-column-indicators {
    float: left;
  }

  .dx-datagrid-table .dx-row > td .dx-sort {
    float: right;
  }

  .dx-datagrid-nowrap .dx-header-row > td > .dx-datagrid-text-content {
    float: left;
  }

  .dx-scrollable-customizable-scrollbars .dx-scrollable-container ::-webkit-scrollbar-thumb {
    background-color: #C1C1C1;
    border-right: 2px solid transparent;
    border-left: 1px solid transparent;
    background-clip: content-box;
  }

  .dx-row-lines {
    cursor: pointer;
  }

  .dx-overlay-content {
    min-width: 47vh;
  }

  .dx-pager .dx-pages {
    float: left;
  }

  .dx-pager .dx-page-sizes {
    float: right;
  }

  .dx-header-row .dx-indicator-alignment-right {
    float: left !important;
  }

  #searchResults {
    overflow-y: hidden;
  }

 /* Portrait tablets and small desktops */
  @media (min-width: 992px) and (max-width: 1349px) {
    .SearchCol {
      max-width: initial !important;
      width: 100% !important;
    }

    .GridCol {
      max-width: initial !important;
      width: 100% !important;
    }
  }

  @media (min-width: 768px) and (max-width: 1349px) {
    .miniSearch {
      margin-bottom: 0.5rem !important;
    }
  }

  /* Landscape phones and portrait tablets */
  @media (max-width: 767px) {
    .searchResultsHeight {
      height: 60vh !important;
    }

    .miniSearch {
      display: block !important;
      margin-bottom: 0.5rem !important;
    }
  }

  /* Portrait phones and smaller */
  @media (max-width: 425px) {
    .searchResultsHeight {
      height: 10vh !important;
    }

  }

  @media (min-height: 0px) and (max-height: 755px) {
    .mDriveButton {
      opacity: 0.9;
    }

      .mDriveButton:hover {
        opacity: 1.0;
      }
  }

</style>



// WEBPACK FOOTER //
// src/views/mDrive.vue